<!-- 审批步骤-->
<template>
  <div class="step-box">
    <div class="step-box-item" :class="{'last-step-box-item':isLastElement}">
      <div class="step-box-item-line"></div>
      <div @click="$parent.openProfile(approvalInfo.dingDingUserId)" class="step-box-item-head">
        <img
          :src="(approvalInfo.dingDingPhotoPath!=null&&approvalInfo.dingDingPhotoPath.length>0)?approvalInfo.dingDingPhotoPath:require('@/assets/images/defaultHead.png')"
        />
        <div class="status" :class="'step-'+approvalInfo.approveStatus+'-icon'"></div>
      </div>
      <div class="step-box-item-main">
        <div class="title-time">
          <div
            class="title"
          >{{currentApplyEmployee==approvalInfo.appoveEmployeeID&&approvalInfo.approveStatus==null?'发起申请':'审批人'}}</div>
          <div class="time">{{approvalInfo.approveDate}}</div>
        </div>
        <div class="author">
          <span>{{approvalInfo.employeeName+to_status}}</span>
        </div>
        <div v-if="approvalInfo.approveReason.length>0" class="content">
          “<span
            v-for="(contentItem,index) in approvalInfo.approveReason"
            :key="index"
            :class="{'atName':contentItem.id.length>0}"
            @click="$parent.openProfile(contentItem.id)"
            v-html="contentItem.layer"
          ></span>”
        </div>
        <filebox
          :fileInfo="{filesrcs: approvalInfo.attachmentPath, filenames: approvalInfo.attachmentName}"
        ></filebox>
      </div>
    </div>
  </div>
</template>
<script>
import filebox from "@/components/Share/Preview/fileBox";
export default {
  data() {
    return {
      statusStr: {
        UNAPPROVED: "(审批中)",
        APPROVED: "(已同意)",
        REJECTED: "(已拒绝)",
        FORWARDED: "(已转交)",
        null: ""
      }
    };
  },
  computed: {
    to_status: function() {
      if (this.approvalInfo.approveStatus == "UNAPPROVED") {
        if (this.currentStep != this.approvalInfo.approverStep) {
          return this.statusStr["null"];
        }
      }
      return this.statusStr[this.approvalInfo.approveStatus];
    }
  },
  components: {
    filebox
  },
  props: {
    currentApplyEmployee: "",
    isLastElement: false,
    currentStep:0,
    approvalInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style lang="less" scoped>
.step-box {
  display: flex;
  width: 100%;
  flex-direction: column;
  .last-step-box-item {
    padding-bottom: 0.4rem !important;
    .step-box-item-line {
      width: 0 !important;
    }
  }
  .step-box-item {
    width: 100%;
    display: flex;
    position: relative;
    padding-bottom: 1rem;
    .step-box-item-line {
      position: absolute;
      left: 0.6667rem;
      height: 100%;
      width: 0.0267rem;
      background: #ffe2a9;
      z-index: 7;
    }
    .step-box-item-head {
      z-index: 8;
      width: 1.3333rem;
      height: 1.3333rem;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .status {
        width: 0.3733rem;
        height: 0.3733rem;
        position: absolute;
        bottom: 0;
        right: 0;
        border-radius: 50%;
      }
      .step-APPROVED-icon {
        border: 0.0267rem solid #fff;
        background: url("../../../assets/icon/dui.png") no-repeat;
        background-size: 100% 100%;
      }
      .step-UNAPPROVED-icon {
        border: 0.0267rem solid #fff;
        background: url("../../../assets/icon/deng.png") no-repeat;
        background-size: 100% 100%;
      }
      .step-REJECTED-icon {
        border: 0.0267rem solid #fff;
        background: url("../../../assets/icon/cuo.png") no-repeat;
        background-size: 100% 100%;
      }
      .step-FORWARDED-icon {
        border: 0.0267rem solid #fff;
        background: url("../../../assets/icon/zhuanjiao.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .step-box-item-main {
      flex: 1;
      margin-left: 0.2667rem;
      .title-time {
        display: flex;
        .time {
          font-size: 0.2933rem;
          color: #999999;
        }
        .title {
          flex: 1;
          font-size: 0.4533rem;
          color: #2c2c2c;
          font-weight: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .author {
        margin-top: 0.2667rem;
        font-size: 0.3467rem;
        color: #666666;
      }
      .content {
        margin-top: 0.2667rem;
        font-size: 0.4rem;
        color: #666666;
        .atName {
          color: #fdc139;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalProcess/approvalProcess.vue